/* A functional offer reminder, not eligibility approval or a checkout override. */
(function () {
  'use strict';
  function readCookie(name, cookies) {
    var pair = (cookies || '').split(';').map(function (part) { return part.trim(); })
      .find(function (part) { return part.indexOf(name + '=') === 0; });
    if (!pair) return '';
    try { return decodeURIComponent(pair.slice(name.length + 1)); } catch (_) { return ''; }
  }
  function isGoogleAdsLanding(search) {
    var params = new URLSearchParams(search);
    if (['gclid', 'gbraid', 'wbraid'].some(function (key) { return (params.get(key) || '').trim().length > 0; })) return true;
    var source = (params.get('utm_source') || '').toLowerCase();
    var medium = (params.get('utm_medium') || '').toLowerCase();
    return ['google', 'googleads', 'google_ads'].includes(source) &&
      ['cpc', 'ppc', 'paid_search', 'paidsearch', 'paid_shopping', 'display'].includes(medium);
  }
  function shouldShowOffer(config, cookies, now, googleAdsVisit) {
    var nativeCode = readCookie('discount_code', cookies).toUpperCase();
    return googleAdsVisit === true && ['WELCOME10', 'CHATGPT10'].includes(config.code) &&
      (nativeCode === config.code || (config.code === 'WELCOME10' && nativeCode === 'CHRISTMAS10')) &&
      config.returningCustomer !== 'true' &&
      now >= Date.parse(config.startsAt) && now <= Date.parse(config.endsAt);
  }
  function isMetaTrialLanding(search) {
    var params = new URLSearchParams(search);
    return ['fb', 'ig', 'facebook', 'instagram'].includes((params.get('utm_source') || '').toLowerCase()) &&
      (params.get('utm_medium') || '').toLowerCase() === 'paid_social' &&
      ['goldstein_creative_trial_20261026', 'gs_acquisition_pilot_20261101'].includes(params.get('utm_campaign'));
  }
  function isOpenAITrialLanding(search) {
    var params = new URLSearchParams(search);
    return params.get('utm_source') === 'chatgpt' &&
      params.get('utm_medium') === 'paid' &&
      params.get('utm_campaign') === 'gs_acquisition_pilot_20261101';
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { readCookie: readCookie, shouldShowOffer: shouldShowOffer, isGoogleAdsLanding: isGoogleAdsLanding, isMetaTrialLanding: isMetaTrialLanding, isOpenAITrialLanding: isOpenAITrialLanding };
  }
  if (typeof document === 'undefined') return;
  function initialise() {
    var root = document.getElementById('goldstein-first-order-offer');
    if (!root || root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';
    var dialog = document.getElementById('goldstein-first-order-dialog');
    var reminder = document.getElementById('goldstein-first-order-reminder');
    if (!dialog || !reminder) return;
    var key = 'goldstein-first-order-offer:WELCOME10:2026';
    var sourceKey = key + ':paid-ads';
    var googleAdsVisit = isGoogleAdsLanding(window.location.search) || isMetaTrialLanding(window.location.search) || isOpenAITrialLanding(window.location.search);
    // Remember only the qualifying visit, never its click ID or customer identity.
    // This keeps the reminder available while the customer browses the shop.
    try {
      if (googleAdsVisit) sessionStorage.setItem(sourceKey, 'yes');
      else googleAdsVisit = sessionStorage.getItem(sourceKey) === 'yes' || sessionStorage.getItem('goldstein-first-order-offer:CHRISTMAS10:2026:google-ads') === 'yes';
    } catch (_) { /* A blocked store still allows the actual ad landing popup. */ }
    // Both approved codes share the same terms. Show only the code Shopify
    // actually carried through, never infer a discount from an advert click alone.
    if (googleAdsVisit && readCookie('discount_code', document.cookie).toUpperCase() === 'CHATGPT10') {
      root.dataset.code = 'CHATGPT10';
      root.querySelectorAll('.gfo-code').forEach(function (element) { element.textContent = 'CHATGPT10'; });
      var discount = root.querySelector('.gfo-discount');
      if (discount) discount.setAttribute('aria-label', 'Offer code CHATGPT10 for 10% off');
      var reminderCopy = root.querySelector('.gfo-reminder-copy');
      if (reminderCopy) Array.from(reminderCopy.childNodes).forEach(function (node) {
        if (node.nodeType === 3) node.textContent = node.textContent.replace('WELCOME10', 'CHATGPT10');
      });
    }
    var previousFocus = null;
    var seenOnPage = false;
    function seen() {
      try { return sessionStorage.getItem(key) === 'seen'; }
      catch (_) { return seenOnPage || readCookie('goldstein_first_offer_seen', document.cookie) === '2026'; }
    }
    function remember() {
      seenOnPage = true;
      try { sessionStorage.setItem(key, 'seen'); }
      catch (_) { document.cookie = 'goldstein_first_offer_seen=2026; Path=/; SameSite=Lax; Secure'; }
    }
    function close() {
      remember();
      if (dialog.open && typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    }
    function open() {
      if (!shouldShowOffer(root.dataset, document.cookie, Date.now(), googleAdsVisit) || dialog.open) return;
      previousFocus = document.activeElement;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else {
        // Older browsers still get an accessible, dismissible inline notice.
        dialog.setAttribute('open', '');
      }
      remember();
      var closeButton = dialog.querySelector('[data-offer-close]');
      if (closeButton) closeButton.focus();
    }
    root.querySelectorAll('[data-offer-close]').forEach(function (button) { button.addEventListener('click', close); });
    root.querySelectorAll('[data-offer-reopen]').forEach(function (button) { button.addEventListener('click', open); });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) close(); });
    function update() {
      var active = shouldShowOffer(root.dataset, document.cookie, Date.now(), googleAdsVisit);
      root.hidden = !active;
      reminder.hidden = !active;
      if (!active) {
        if (dialog.open) close();
        return;
      }
      if (!seen()) {
        // Do not open over an already visible site/consent modal.
        var otherModal = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]'))
          .some(function (element) { return element !== dialog && !element.hidden && element.getClientRects().length > 0; });
        if (otherModal) window.setTimeout(update, 1500);
        else open();
      }
    }
    window.addEventListener('pageshow', update);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) update(); });
    window.setTimeout(update, 700);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
})();
